import { Box, Button, Modal, Stack, styled, Typography } from '@mui/material';
import { LoadingButton } from 'components';
import { fontFamily } from 'theme/overrides/fontFamily';

export const StyledModal = styled(Modal)(({ theme }) => ({
  maxWidth: theme.spacing(68.75),
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  margin: 'auto',
  borderRadius: theme.spacing(1),
}));

export const StyledModalInner = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  padding: theme.spacing(3),
  color: theme.palette.grey[900],
  background: theme.palette.grey[50],
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const StyledTitle = styled(Typography)({
  fontFamily: fontFamily.drukWideMedium,
  fontWeight: 500,
  lineHeight: '150%',
  textAlign: 'left',
});

export const StyledDescription = styled(Typography)({
  fontSize: 12,
  fontStyle: 'normal',
  fontWeight: 400,
  textAlign: 'left',
  lineHeight: '150%',
});

export const StyledBackButton = styled(Button)(({ theme }) => ({
  width: 'auto',
  padding: 0,
  alignSelf: 'start',
  color: theme.palette.grey[500],
  '&:hover': {
    background: 'initial',
    color: theme.palette.grey[600],
  },
}));

export const StyledError = styled(Typography)({});

export const StyledActionButtonsContainer = styled(Stack)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  flexDirection: 'row',
  justifyContent: 'flex-end',
}));

export const StyledCancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[400],
}));

export const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  '&.Mui-disabled': {
    backgroundColor: theme.palette.grey[200],
  },
}));

export const StyledAudioInfoWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isError',
})<{
  isError: boolean;
}>(({ theme, isError }) => ({
  borderRadius: theme.spacing(1),
  border: isError ? `1px solid ${theme.palette.error.main}` : undefined,
}));
